<template>
  <v-dialog max-width="500px" v-model="dialog" @keydown.enter.prevent="save">
    <v-card>
      <v-card-title>
        <span class="headline">Item Social ({{ this.rules.name }})</span>
        <v-spacer/>
        <v-switch
            class="mb-5"
            v-model="model.enabled"
            label="Enabled"
            color="success"
            hide-details
        />
      </v-card-title>
      <v-card-text>
        <v-row dense>
          <v-col cols="12" md="12" sm="12">
            <v-btn @click="showPreview()" class="mr-2" small>View JSON</v-btn>
          </v-col>
        </v-row>
        <v-row dense class="mb-4">
          <v-col cols="12" sm="9" md="9">
            <r-item-dropdown :model.sync="model.key"/>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <v-text-field v-model.number="model.rarity" label="Rarity:" hide-details/>
          </v-col>
          <v-col cols="12" sm="12" md="12"/>
        </v-row>
        <v-row dense>
          <v-expansion-panels>
            <r-guard-panel :model.sync="model.guard"/>
            <r-reward-panel :model.sync="model.playerReward" title="Player Reward"/>
            <r-reward-panel :model.sync="model.friendReward" title="Friend Reward"/>
          </v-expansion-panels>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn @click="cancel" color="blue darken-1" text>
          Cancel
        </v-btn>
        <v-btn @click="save" color="blue darken-1" text>
          Save
        </v-btn>
      </v-card-actions>
      <r-preview-dialog ref="preview-dialog"></r-preview-dialog>
    </v-card>
  </v-dialog>
</template>
<script>

import {ViewRules} from "@/common/ViewRules";
import {ItemSocial} from "@/modules/redactor/models/items-social/ItemSocial";


import RGuardPanel from "@/modules/redactor/views/guard/r-guard-panel";
import RRewardPanel from "@/modules/redactor/views/reward/r-reward-panel.vue";
import RItemDropdown from "@/modules/redactor/views/item/r-item-dropdown";
import RPreviewDialog from "@/modules/redactor/views/preview/r-preview-dialog.vue";

export default {
  name: "r-item-social-dialog",
  components: {RPreviewDialog, RItemDropdown, RRewardPanel, RGuardPanel},
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    model: new ItemSocial(),
    rules: ViewRules.READONLY,
  }),
  methods: {
    show(rules, model) {
      this.dialog = true;
      this.rules = rules;
      this.model = model || new ItemSocial();
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    save() {
      if (this.model.valid()) {
        this.resolve(this.model);
        this.discard();
      } else {
        this.$alert("Invalid config!");
      }
    },
    cancel() {
      this.reject();
      this.discard();
    },
    discard() {
      this.dialog = false;
    },
    showPreview() {
      this.$refs['preview-dialog'].show(this.rules, this.model, ItemSocial)
          .then((result) => {
            Object.assign(this.model, result);
          })
          .catch((e) => {
            this.$alert("Failed to parse config!" + e.message);
          });
    },
  }
};
</script>